import IConsent from "./IConsent";
import ConsentCode from "./ConsentCodeEnum";

export default class Consent implements IConsent
{
    public readonly code: ConsentCode;
    public readonly granted: boolean;

    constructor(props: IConsent)
    {
        this.code = props.code;
        this.granted = props.granted;
    }
}
